export const colorConstants = {
    primary: '#0b2b61',
    secondary: '#1ea2cb',
    yellow: '#e2fb27',
    white: '#ffffff'
};
